// extracted by mini-css-extract-plugin
export default {"heading":"n3J1PMBL","subList":"GhATKfYI","venueList":"Zy9LY7iC","subtitle":"dbb7USng"};